const client_name = 'web';
const secret = 'f46d0c0603206b2f1515462e57284132';
const base_url = 'https://www.36bom.com/api/';

export class Response {

    constructor(success, errorMessage, data) {
        this.success = success;
        this.errorMessage = errorMessage;
        this.data = data;
    }
    static from_json(jsonString) {
        return new Response(jsonString.success, jsonString.error, jsonString.data);
    }

    is_successful() {
        return this.success;
    }

    get_error_message() {
        return this.errorMessage;
    }

    get_data() {
        return this.data;
    }
}

function get_signature(inputs) {
    const keys = Array.from(inputs.keys()).sort();
    let buildup = secret;
    for (let key of keys) {
        buildup += inputs.get(key);
    }

    const md5 = require('md5');
    return md5(buildup);
}

function build_headers(inputs) {
    const signature = get_signature(inputs);
    return {
        'CLIENT': client_name,
        'SIGNATURE': signature,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };
}

export async function get(inputs, service, endpoint) {
    const headers = build_headers(inputs);
    let url = base_url + service + '.php' + '?' + 'method=' + endpoint;
    for (let i = 0; i < inputs.length; i++) {
        url += '&' + inputs[i].key + '=' + inputs[i].value;
    }

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: headers
        });

        // Check if the request was successful (status in the 200-299 range)
        if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.statusText);
        }

        // Parse the response body as JSON
        let result = Response.from_json(await response.json());
        if (!result.success) {
            throw new Error('Network response was not ok: ' + result.get_error_message());
        }
        return result;
    } catch (error) {
        console.error('Fetch error:', error);
        return new Response(false, error.message, null);
    }
}

export async function post(inputs, service, endpoint) {
    const headers = build_headers(inputs);
    let url = base_url + service +'.php';
    inputs.set('method', endpoint);
    const body = JSON.stringify(Object.fromEntries(inputs));

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: body
        });

        // Check if the request was successful (status in the 200-299 range)
        if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.statusText);
        }

        // Parse the response body as JSON
        let result = Response.from_json(await response.json());
        if (!result.success) {
            throw new Error('Network response was not ok: ' + result.get_error_message());
        }
        return result;
    } catch (error) {
        console.error('Fetch error:', error);
        return new Response(false, error.message, null);
    }
}